import { alpha } from '@mui/material/styles';

export const useSx = ({ color, children = undefined }) => ({
  accordionSx: {
    border: '1px solid',
    borderColor: alpha(color, 0.6),
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&.Mui-expanded': {
      margin: 'auto'
    }
  },
  accordionSummarySx: {
    // don't show pointer if there are no children and the accordion can't be expanded
    ...(children ? {} : { cursor: 'default !important' }),
    backgroundColor: alpha(color, 0.1),
    borderBottom: '1px solid',
    borderBottomColor: alpha(color, 0.08),
    paddingLeft: 1.5,
    paddingRight: 1.5,
    marginBottom: '-1px',
    minHeight: 41,
    '&.Mui-expanded': {
      minHeight: 41
    },
    '&.Mui-focused': {
      backgroundColor: alpha(color, 0.18)
    },

    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
      margin: 0,
      '&.Mui-expanded': {
        margin: 0
      }
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      padding: 1,
      marginRight: -1,
      color
    }
  },
  accordionDetailsSx: {
    backgroundColor: alpha(color, 0.05),
    padding: 1.5,
    paddingLeft: 2,
    paddingRight: 2
  }
});
